import React from 'react'
import PropTypes from 'prop-types'
import { OneProject } from './styles'
import TitleProject from './title-project/TitleProject'
import ImageProject from './image-project/ImageProject'
import ButtonProject from './button-project/ButtonProject'
import DescriptionProject from './description-project.js/DescriptionProject'
import TechProject from './technologies-projects/TechProject'
import { FlexContainer } from '../../../../styles/atoms/StyledComponents'
import { cutString } from './splitArray/cutString'
import { deleteSpaces } from './splitArray/deleteSpaces'

const Project = ({ name, urlImage, urlGitHub, urlPage, description, technologies }) => {
  
  const newTechs = deleteSpaces(cutString(technologies[0], ','))

  return (
    <OneProject
      data-testid="project"
    >
      
      <TitleProject name={name} />
      
      <ImageProject 
        name={name}
        urlImage={urlImage}
      />

      <FlexContainer
        flexDirection="column"
        padding="10px"
        alignItems="center"
      >
        
        <ButtonProject
          text="Code"
          url={urlGitHub} 
          styles={{
            color: "#F7DF1E",
            backgroundColor: "transparent",
            borderRadius: "6px",
            border: "2px solid #F7DF1E",
            width: "50%",
            marginBottom: "15px",
            fontSize: "1.2rem",
            fontWeight: "bold",
          }}
        />

        <ButtonProject
          text="Demo"
          url={urlPage} 
          styles={{
            color: "#FFFFFF",
            backgroundColor: "#202020",
            borderRadius: "6px",
            width: "50%",
            marginBottom: "15px",
            fontSize: "1.2rem",
            fontWeight: "bold",
          }}
        />
        
      </FlexContainer>

      <DescriptionProject text={description}/>
      <TechProject arrayString={newTechs} />
      
    </OneProject>
  )
}

Project.propTypes = {
  name: PropTypes.string.isRequired,
  urlImage: PropTypes.string.isRequired,
  urlGitHub: PropTypes.string.isRequired,
  urlPage: PropTypes.string.isRequired,
  
}

export default Project
